import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', component: () => import('@/pages/Layout')},
    {path: '/login', component: () => import('@/pages/permission/Login')},
    {path: '/verify', component: () => import('@/pages/Verify')},
    {path: '/print', component: () => import('@/pages/Print')},
    {path: '/article', component: () => import('@/pages/Article')},
    {path: '/paper', component: () => import('@/pages/Paper')}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js